import { useEffect, useRef } from 'react';
import { Label, Text } from '../../../../../styles/component.styles';

const ContactFormAddSection = ({ onChange }) => {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current) {
      onChange({
        content: {},
        metadata: {
          padding: '2rem 0',
          margin: '2rem auto',
          background: 'transparent',
          align: 'center',
        }
      });
      hasInitialized.current = true;
    }
  }, [onChange]);

  return (
    <>
      <Label>Contact Form</Label>
      <Text>This section will render the default contact form. Styling is not currently configurable in V1.</Text>
    </>
  );
};

export default ContactFormAddSection;